

const scale = (num: number, in_min: number, in_max: number, out_min: number, out_max: number): number => {
  return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
}

const formatNum = (num: number, precision: 1|2 = 2): number => {
  return Number.parseFloat((Math.round(num * 100) / 100).toFixed(precision))
}

export const dBFS = (volume: number, precision: 1|2 = 2): number => {
  return formatNum(scale(volume, 0, 100, -48, 0), precision)
}

export const dBFSToGain = (volume: number): number => {
  // expects value between 0 and 100 and outputs a value between 0 and 1
  if (volume === 0) return 0
  return Math.pow(10, dBFS(volume) / 20)
}
